import gql from 'graphql-tag'

export const GET_CHARGES_TYPES_AND_CHARGES = gql`
query getChargeTypesAndCharges($pointTypeId:uuid!, $clientInvoiceId:uuid!){
  chargeTypes: clientPointCharge(where: {pointType: {_eq: $pointTypeId}}) {
    id
    ChargeType {id type}
  }
  charges: clientCharges(where: {clientInvoiceId: {_eq: $clientInvoiceId}, pointType: {_eq: $pointTypeId}}) {
    id
    amount
    note
    query
    chargeType
  }
  chargesNA: clientChargesNA(where: {clientInvoiceId: {_eq: $clientInvoiceId}, pointType: {_eq: $pointTypeId}}) {
    id
    chargesNotApplicable
  }
}
`

export const GET_ALL_CHARGES = gql`
query getAllCharges($clientInvoiceId:uuid!){
  chargeTypes: clientPointCharge{
    id
    pointType
    chargeType
  }
  charges: clientCharges(where: {clientInvoiceId: {_eq: $clientInvoiceId}}) {
    id
    pointType
    amount
    note
    query
    chargeType
    ChargeType {id type}
  }
  chargesNA: clientChargesNA(where: {clientInvoiceId: {_eq: $clientInvoiceId}}) {
    id
    pointType
    chargesNotApplicable
  }
  clientInvoices(where: {id: {_eq: $clientInvoiceId}}) {
    id
    billingFreight
    Order{ id orderDetails{ id splOfferedFreight splOfferedFreightNote}}
  }
}
`
export const GET_LAST_CLIENT_INVOICE = gql`
query getLastClientInvoice($startDate:timestamptz!){
  clientInvoices(where: {invoiceDate: {_gte: $startDate}}, order_by: {invoiceDate: desc}, limit: 1) {
      id
      invoiceNumber
  }
}
`
export const GET_CLIENT_INVOICE_WHILE_ACCEPT = gql`
query getClientInvoiceWhileAccept($id:uuid!){
  clientInvoices(where: {id: {_eq: $id}}) {
      id
      statusId
      invoiceNumber
  }
}
`
